import { H5pPlugin } from './h5p'
import { imagePlugin } from './image-with-serlo-config'

export const extraSerloPlugins = {
  h5p: H5pPlugin,
  image: imagePlugin,
}
